/* eslint-disable react-native/no-color-literals */
import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  RightCurved: {
    backgroundColor: `white`,
    borderRadius: 100,
    height: 30,
    position: "absolute",
    right: -15,
    top: 59,
    width: 30,
    zIndex: 1,
  },
  container: { height: "100%" },
  dividerView: {
    borderColor: colors.lightGrey,
    borderRadius: 1,
    borderStyle: "dashed",
    borderWidth: 1,
    height: 1,
    marginVertical: 10,
    width: "100%",
    zIndex: 1,
  },
  dividerViewStyle: {
    backgroundColor: colors.white,
    bottom: 0,
    height: 1,
    left: 0,
    position: "absolute",
    width: "100%",
    zIndex: 1,
  },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  emptyTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 25,
    padding: 20,
    textAlign: "center",
  },
  expiryText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 12,
    marginTop: 5,
  },
  flatListContainer: {
    padding: 10,
  },
  header: { borderBottomLeftRadius: 10, borderBottomRightRadius: 10 },
  headerTabBarContainer: {
    alignSelf: "center",
    borderColor: colors.white,
    borderRadius: 20,
    borderWidth: 2,
    flexDirection: "row",
    height: 30,
    width: "90%",
  },
  image: {
    alignSelf: "flex-end",
    borderRadius: 15,
    height: 80,
    marginTop: 10,
    width: 80,
  },
  leftCurved: {
    backgroundColor: `white`,
    borderRadius: 100,
    height: 30,
    left: -15,
    position: "absolute",
    top: 59,
    width: 30,
    zIndex: 1,
  },
  linearGradient: { borderBottomLeftRadius: 10, borderBottomRightRadius: 10, paddingTop: 10 },
  mb20: { marginBottom: 20 },
  row: { alignItems: "center", flexDirection: "row" },
  selectedTabBar: {
    backgroundColor: colors.white,
    borderRadius: 30,
    margin: 1,
  },
  tabBar: { alignItems: "center", flex: 1, justifyContent: "center" },
  text: { fontFamily: typography.primary.normal },
  tierContentContainer: {
    borderRadius: 10,
    marginTop: 10,
    padding: 20,
    paddingBottom: 24,
    paddingLeft: 0,
  },
  tierSpendText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
  },
  voucherContainer: {
    backgroundColor: colors.white,
    borderRadius: 10,
    elevation: 1,
    marginHorizontal: 5,
    marginTop: 20,
    padding: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
  },
  voucherDescription: {
    color: colors.darkerGrey,
    fontFamily: typography.primary.normal,
    fontSize: 12,
  },
  whiteDash: {
    borderColor: "white",
    borderStyle: "dashed",
    borderWidth: 1,
    marginBottom: 10,
    marginTop: 10,
    width: "100%",
  },
})
